import { Validator } from 'vee-validate';
import { isValidNumber } from 'libphonenumber-js';
import i18n from 'src/i18n';

Validator.extend('phoneNumber', {
  getMessage: field => i18n.t('generic.validations.phone'),
  validate: (value) => {
    return isValidNumber(value);
  }
});


Validator.extend('max_discount_value', {
  getMessage: field => i18n.t('generic.validations.percentage'),
  validate: (value, [discountType]) => {
    if (discountType === 'percentage') {
      return value <= 100;
    }
    return true;
  }
});

let notEmptyObject = (value) => {
  return value && typeof value === 'object' && Object.keys(value).length
};
Validator.extend('not_empty_object', notEmptyObject);
